export const getRoutesProps = (params) => {
  const { parentPath = "", route, role, permissions, parent } = params;
  const fullPath = parentPath + route.path;

  if (route.children?.length) {
    return route.children
      .map((child) =>
        getRoutesProps({
          parentPath: fullPath,
          route: child,
          role,
          permissions,
          parent: route,
        })
      )
      .filter(Boolean);
  }

  if (hasPermissions(route, role, permissions)) {
    return {
      path: fullPath,
      component: route.component,
      label: route.label,
      icon: route.icon,
      parent,
    };
  }

  return undefined;
};

const hasPermissions = (route, role, permissions) => {
  const isValidRole =
    !route.hasOwnProperty("authorizedRoles") ||
    route.authorizedRoles.includes(role);

  const userHasPermissions =
    !route.hasOwnProperty("permissionKey") ||
    !!permissions[route?.permissionKey];

  return isValidRole && userHasPermissions;
};

export const getRoutesPropsWithParentsTree = (params) => {
  const routesProps = getRoutesProps(params).filter(Boolean);

  const parentsTree = routesProps.reduce(
    (routesPropsWithParentsTree, routeProps) => {
      routesPropsWithParentsTree.push({
        label: routeProps[0]?.parent.label,
        path: routeProps[0]?.parent.path,
        icon: routeProps[0]?.parent?.icon,
        children: routeProps,
      });
      return routesPropsWithParentsTree;
    },
    []
  );

  return parentsTree;
};
